"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriftDataGrid = exports.DataGrid = exports.DetailPanelToggleColumn = exports.DetailPanelToggle = void 0;
const react_1 = __importDefault(require("react"));
const x_license_1 = require("@mui/x-license");
const x_data_grid_pro_1 = require("@mui/x-data-grid-pro");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const ExpandMore_1 = __importDefault(require("@mui/icons-material/ExpandMore"));
const muiLicense_1 = require("../../assets/muiLicense");
x_license_1.LicenseInfo.setLicenseKey(muiLicense_1.muiLicense);
const DetailPanelToggle = (props) => {
    const { id, value: isExpanded } = props;
    const apiRef = (0, x_data_grid_pro_1.useGridApiContext)();
    // To avoid calling ´getDetailPanelContent` all the time, the following selector gives an object with the detail panel content for each row id.
    const contentCache = (0, x_data_grid_pro_1.useGridSelector)(apiRef, x_data_grid_pro_1.gridDetailPanelExpandedRowsContentCacheSelector);
    // If the value is not a valid React element, it means that the row has no detail panel.
    const hasDetail = react_1.default.isValidElement(contentCache[id]);
    return (react_1.default.createElement(IconButton_1.default, { size: "large", tabIndex: -1, disabled: !hasDetail, "aria-label": isExpanded ? 'Close' : 'Open' },
        react_1.default.createElement(ExpandMore_1.default, { sx: (theme) => ({
                transform: `rotateZ(${isExpanded ? 180 : 0}deg)`,
                transition: theme.transitions.create('transform', {
                    duration: theme.transitions.duration.shortest,
                }),
            }), fontSize: "inherit" })));
};
exports.DetailPanelToggle = DetailPanelToggle;
exports.DetailPanelToggleColumn = Object.assign(Object.assign({}, x_data_grid_pro_1.GRID_DETAIL_PANEL_TOGGLE_COL_DEF), { minWidth: 52, renderCell: (params) => react_1.default.createElement(exports.DetailPanelToggle, { id: params.id, value: params.value }) });
__exportStar(require("@mui/x-data-grid-pro"), exports);
var x_data_grid_pro_2 = require("@mui/x-data-grid-pro"); // to maintain backward compatability with unlicensed DataGrid
Object.defineProperty(exports, "DataGrid", { enumerable: true, get: function () { return x_data_grid_pro_2.DataGridPro; } });
var DriftDataGrid_1 = require("./DriftDataGrid");
Object.defineProperty(exports, "DriftDataGrid", { enumerable: true, get: function () { return DriftDataGrid_1.DriftDataGrid; } });
//# sourceMappingURL=DataGrid.js.map